import { useEffect, useState } from 'react';
import { fetchImagemBlobUrl } from '../services/api';

/**
 * Carrega uma imagem servida pela API e devolve um object URL pronto para `src`.
 *
 * Usar o caminho da API direto no `src` não funciona: `<img>` é requisição do
 * navegador, sem o header Authorization que o interceptor adiciona. As rotas de
 * foto e logo são `permitAll` justamente para permitir isso, mas sem JWT não há
 * claim de tenant — o TenantContext fica vazio e a consulta cai no schema de
 * controle, falhando com "table_usuario does not exist". Buscando pelo Axios, o
 * token vai no header e o tenant vem do claim.
 *
 * Revoga o object URL ao trocar de imagem e ao desmontar, para não vazar blob.
 *
 * @param rota  caminho na API (ex.: `/parametros/logo`); nulo desliga a busca
 * @param chave identifica a imagem atual — tipicamente o objectName guardado no
 *              cadastro. Vazio significa "não há imagem" e desliga a busca,
 *              evitando um 404 por render; quando muda (upload de uma nova), a
 *              busca é refeita, senão a tela ficaria com a imagem antiga, já que
 *              a rota é sempre a mesma
 * @returns object URL, ou null enquanto carrega / quando não há imagem
 */
export default function useImagemBlobUrl(rota, chave) {
    const [blobUrl, setBlobUrl] = useState(null);

    useEffect(() => {
        if (!rota || !chave) { setBlobUrl(null); return; }

        let criada = null;
        let cancelado = false;

        fetchImagemBlobUrl(rota).then(url => {
            if (cancelado) { if (url) URL.revokeObjectURL(url); return; }
            criada = url;
            setBlobUrl(url);
        });

        return () => {
            cancelado = true;
            if (criada) URL.revokeObjectURL(criada);
        };
    }, [rota, chave]);

    return blobUrl;
}
